import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { GenericTableModule } from "../../../../dms/layout/generic-table/generic-table.module";
import { CalendarioModule } from "../../../../shared/components/calendario/calendario.module";
import { CommunicationsComponent } from "./communications.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        DropDownListModule,
        ReactiveFormsModule,
        GenericTableModule,
        CalendarioModule
    ],
    declarations: [
        CommunicationsComponent
    ],
    exports: [
        CommunicationsComponent
    ]
})
export class CommunicationsModule { }
